// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"80f301d2","365":"9356a574","488":"eca3b6a1","732":"4391bec5","977":"ea09065e"}[chunkId] + ".chunk.js";
};